export const GET_RATE_CONFIGS_SUCCESS = 'GET_RATE_CONFIGS_SUCCESS';
export const GET_RATE_CONFIGS_REQUEST = 'GET_RATE_CONFIGS_REQUEST';
export const GET_RATE_CONFIGS_FAILURE = 'GET_RATE_CONFIGS_FAILURE';
export const GET_RATE_CONFIGS_REST = 'GET_RATE_CONFIGS_REST';
export const getRateConfigsSuccess = (payload) => ({
    type: GET_RATE_CONFIGS_SUCCESS,
    payload,
});
export const getRateConfigsRequest = (payload) => ({
    type: GET_RATE_CONFIGS_REQUEST,
    payload,
});
export const getRateConfigsFailure = (payload) => ({
    type: GET_RATE_CONFIGS_FAILURE,
    payload,
});
export const getRateConfigsRest = () => ({
    type: GET_RATE_CONFIGS_REST,
});
